export default __webpack_public_path__ + "static/media/accomplishment.90498a13.jpg";